import { alphabet } from "./alphabet";
import { baseTenNumbers } from "./base-ten-numbers";

export const alphanumeric = [...alphabet, ...baseTenNumbers];
